<form (ngSubmit)="onGoToPageClick()" class="flex items-center">
    <div class="paginator-go-to-page-label mat-caption mx-1">gehe zu Seite:</div>
    <mat-form-field style="width: 56px">
        <input matInput [max]="paginator.getNumberOfPages()" min="1" type="number" [formControl]="targetPageForm" />
    </mat-form-field>
    <button mat-icon-button [disabled]="!targetPageForm.value || targetPageForm.invalid" type="submit">
        <fa-icon icon="arrow-right"></fa-icon>
    </button>
</form>
<ng-content></ng-content>
